import React from 'react';
import { PasswordForgetForm } from '../PasswordForget';
import PasswordChangeForm from '../PasswordChange';
import { AuthUserContext, withAuthorization } from '../Session';
import CustomNavBar from '../CustomNavBar';
import CardSection from '../CardSection';
import SignOut from '../SignOut';
import axios from '../../axios';
import * as ROUTES from '../../constants/routes';
import * as cardTypes from '../../constants/cardTypes';
import { connect } from 'react-redux';
import * as actionTypes from '../../store/actions';
import {Link} from 'react-router-dom'


class Rewards extends React.Component{ 

  constructor(props) {
    super(props);
    this.state = {
      userRewards: null
    };
  }

  componentDidMount(){
    const {firebaseToken, currUser } = this.props.location.state;
    this.props.onUserRetrieved(currUser);

    const condition = authUser => !!authUser;
      if(condition && this.props.currFirebaseToken != null){
        console.log("Reward call made");
        this.grabDetails(this.props.currFirebaseToken);
      }else{
        console.log("Reward cannot make call");
      }
  }

  grabDetails(firebaseToken) {
    
    const formData = new FormData();
    formData.append('FirebaseToken', firebaseToken);
    axios.post(
        "/GetRewards",
        formData
        )
        .then(res => {
          if(res.data != null){
            console.log("Reward Offers Grabbed");
            console.log(res.data);
            this.setState({
              userRewards : res.data
            });
          }else{
            this.setState({
              userRewards : null
            });
            console.log("Failed to grab Rewards");
          }
        })
        .catch(error => {
            console.log(error);
        });
  }

  render (){ return(
      <AuthUserContext.Consumer>
      {authUser => (
        <div style={{paddingTop:  '10rem', backgroundColor: 'lightgray'} }>
           <CustomNavBar onClick={i => this.handleClick(i)} showButton = {this.props.showButton} />
          {this.state.userRewards != null &&
                this.state.userRewards.map(
                  (number) => 
                    
                      <CardSection 
                        key={number.Id} 
                        RewardId={number.Id}
                        cardType={cardTypes.REWARD} 
                        Title={number.Title} 
                        RewardType={number.RewardType}  
                        Description={number.Description}
                        PointsCost={number.PointsCost} 
                        />)
            }

        </div>
        )}
        </AuthUserContext.Consumer>
      );
  }

}

const mapStateToProps = state => {
  return {
    currFirebaseToken: state.currFirebaseToken,
    currUser: state.currUser
  };
}

const mapDispatchToProps = dispatch => {
  return {
    onIngredientsAdded: (theToken) => dispatch({type: actionTypes.SAVE_TOKEN, firebaseToken: theToken}),
    onUserRetrieved: (theUser) => dispatch({type: actionTypes.SAVE_USER, user: theUser}),
  }
}

const condition = authUser => !!authUser;
export default connect(mapStateToProps, mapDispatchToProps)(withAuthorization(condition)(Rewards));